import Marquee from "react-fast-marquee";
import { DESTINATIONS } from "@/data/content";

export default function DestinationsMarquee() {
  return (
    <div
      data-testid="destinations-marquee"
      className="border-y border-[#d4af37]/15 bg-[#101C3E]/40 py-7 overflow-hidden"
    >
      <Marquee speed={35} gradient={false} pauseOnHover>
        {DESTINATIONS.map((d) => (
          <span key={d.name} className="flex items-center">
            <span className="font-display text-3xl md:text-5xl font-light text-[#d4af37]/75 px-8 whitespace-nowrap">
              {d.name}
            </span>
            <span className="text-[#d4af37]/35 text-sm">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
